import {
  Box,
  Grid,
  Pagination as MuiPagination,
  Typography,
  styled,
} from "@mui/material";

import Select from "./Select";
import useIsMobileView from "hooks/useIsMobileView";
import { useSearchParams } from "react-router-dom";

const perPageItems = [
  {
    value: 5,
  },
  {
    value: 10,
  },
  {
    value: 20,
  },
  {
    value: 50,
  },
];

function Pagination({ count, onChange, perPage }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = +searchParams?.get("page") || 1;
  const isMobileView = useIsMobileView();

  const handleChangePage = (_, value) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      page: value,
    });

    if (onChange) {
      onChange({ page: value, perPage });
    }
  };

  const handleChangePerPage = (e) => {
    const value = e?.target?.value;
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      page: 1,
      perPage: value,
    });

    onChange({ page: 1, perPage: value });
  };

  return (
    <>
      {count > 0 && (
        <>
          <Grid container spacing={0.5} mt={3} mb={2} alignItems="center">
            <Grid item md={3} xs={6} order={{ md: 0, xs: 2 }}>
              <PerPageWrapper>
                <Typography mr={1} variant="subtitle2" color="text.secondary">
                  تعداد نمایش
                </Typography>

                <SmallSelect
                  onChange={handleChangePerPage}
                  items={perPageItems}
                  value={perPage || 10}
                  itemValue="value"
                  itemText="value"
                  justifyContent="center"
                />
              </PerPageWrapper>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              order={{ md: 1, xs: 1 }}
              mb={isMobileView ? 2 : 0}
            >
              <MuiPaginationStyle
                page={page}
                onChange={handleChangePage}
                count={count}
                size="small"
              />
            </Grid>
            <Grid item md={3} xs={6} textAlign="right" order={{ md: 2, xs: 3 }}>
              <Typography variant="subtitle2" color="text.secondary">
                نمایش صفحه {page} از {count}
              </Typography>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
}

const PerPageWrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
}));

const SmallSelect = styled(Select)(({ theme }) => ({
  width: "auto",

  ".MuiSelect-select": {
    padding: theme.spacing(0.5, 1),
    paddingRight: `${theme.spacing(3)} !important`,
    fontSize: "12px",
  },

  ".MuiButtonBase-root": {
    width: "16px",
    height: "16px",
    top: "50%",
    right: "2px",
    transform: "translateY(-50%)",
    padding: 0,
  },
}));

const MuiPaginationStyle = styled(MuiPagination)(({ theme }) => ({
  ".MuiPagination-ul": {
    justifyContent: "center",

    ".MuiButtonBase-root": {
      background: theme.palette.secondary.light,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "12px",
      lineHeight: "0",
      color: theme.palette.common.white,
      
      "&.Mui-selected": {
        color: theme.palette.modules.buttonColor,
        background: theme.palette.secondary.main,
      },
    },
  },
}));

export default Pagination;
